<template>
    <v-card class="pa-4">
        <v-container>
            <v-row class="confirm-text-container">
                <v-col cols="12" class="confirm-title text-center font-weight-bold">
                    {{ payload.title }}
                </v-col>
                <v-col cols="12" class="confirm-text text-center">
                    {{ payload.text }}
                </v-col>
            </v-row>
            <v-row class="justify-space-between">
                <v-col cols="6">
                    <v-btn block outlined color="red" @click="handleCloseDialog(false)">
                        {{ payload.actions.cancel  }}
                    </v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn block color="success" @click="handleCloseDialog(true)">{{ payload.actions.confirm }}</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import BaseDialog from '../BaseDialog.vue';

export default {
    name: "ConfirmDialog",
    components: {
        BaseDialog
    },
    emits: ['submit'],
    props: {
        payload: {
            type: Object,
            required: true
        },
    },
    mounted() {
        console.log(this.payload);
    },
    data() {
        return {
            // dialog: this.display
            display: true
        }
    },
    methods: {
        handleCloseDialog(value) {
            this.$emit('submit', value)
        }
    }
}
</script>
<style lang="scss">
.confirm-title {
    font-size: 1.75rem;
}
.confirm-text {
    font-size: 1.125rem;
}
</style>